export default{

    getBet: state => {
        let bet = state.chosenBets
        var betValue = ''
        if (bet[0]) {
            betValue = bet[bet.length - 1]
        }
        return betValue
    } 
}